import {
  ApiKeysPendingView,
  ApiKeysView
} from '@/components/api-keys/api-keys-view'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard_/api-keys')({
  component: RouteComponent,
  pendingComponent: ApiKeysPendingView,
  beforeLoad: ({ context: { user } }) => {
    if (!user?.isAdmin) throw redirect({ to: '/sign-out' })
    return { breadcrumb: 'API Keys' }
  },
  loader: async ({ context: { orpc, queryClient } }) => {
    await queryClient.ensureQueryData(
      orpc.backoffice.apiKeys.getAll.queryOptions()
    )
  }
})

function RouteComponent() {
  const { orpc } = Route.useRouteContext()

  return <ApiKeysView orpc={orpc} />
}
